import script from "./BlogLabels.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlogLabels.vue?vue&type=script&lang=ts&setup=true"

import "./BlogLabels.vue?vue&type=style&index=0&id=735db837&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735db837"]])

export default __exports__